import API from "..";

export default class Template {
  constructor({
    templateOwnerEmail,
    templateName,
    templateJSON,
    templateType,
    isPublic,
    createdDate,
    lastModifiedDate,
    messages,
  }) {
    this.templateOwnerEmail = templateOwnerEmail;
    this.templateName = templateName;
    this.templateJSON = templateJSON;
    this.templateType = templateType;
    this.isPublic = isPublic;
    this.createdDate = createdDate;
    this.lastModifiedDate = lastModifiedDate;
    this.messages = messages;
  }

  static async getAllTemplates() {
    const api = await API();
    const { data } = await api.get(`/template`);
    return data.result.map((d) => new Template(d));
  }

  static async getMyTemplates(
    templateName,
    templateType,
    includePublic = false,
    validateTemplate = true,
    page = 0,
    resultsPerPage = 0,
  ) {
    const api = await API();
    const { data } = await api.get(
      `template/me?templateName=${encodeURIComponent(templateName)}&templateType=${templateType}&includePublic=${includePublic}&validateTemplate=${validateTemplate}&page=${page}&resultsPerPage=${resultsPerPage}`,
    );

    if (data.result) {
      return data.result.map((d) => new Template(d));
    } else {
      return [];
    }
  }

  static async add(template) {
    const api = await API();
    const { data } = await api.post(`/template`, template);
    return data;
  }

  static async update(template) {
    const api = await API();
    const { data } = await api.put(`/template`, template);
    return data;
  }

  static async delete(templateName, templateType) {
    const api = await API();
    const { data } = await api.delete(
      `/template?templateName=${encodeURIComponent(templateName)}&templateType=${templateType}`,
    );
    return data;
  }

}
